<script lang="ts">
	import { page } from '$app/state';
	import { createTableOfContents, melt } from '@melt-ui/svelte';
	import { debounce } from 'lodash-es';
	import { onMount } from 'svelte';

	const scrollOffset = 120;
	const {
		elements: { item },
		states: { headingsTree, activeHeadingIdxs }
	} = createTableOfContents({
		selector: 'main',
		activeType: 'highest',
		rootMargin: `-${scrollOffset}px 0px 0px`,
		scrollOffset,
		headingFilterFn: (heading) => heading.dataset.toc === 'true'
	});

	onMount(() => {
		if (page.url.hash) {
			const section = document.querySelector(page.url.hash);
			if (section) {
				setTimeout(() => {
					window.scrollTo({
						top: section.getBoundingClientRect().top + window.scrollY - scrollOffset,
						behavior: 'smooth'
					});
				}, 1000);
			}
		} else {
			document.getElementById('side-nav')?.scrollTo({ left: 0, behavior: 'instant' });
		}
	});

	const onActiveHeadingChange = debounce((idxs: number[]) => {
		if (idxs.length) {
			const activeIdx = idxs[idxs.length - 1];
			if (!activeIdx) return;
			const activeId = $headingsTree[activeIdx].id;
			const item = document.querySelector(`a[data-id=${activeId}]`);
			if (item) {
				setTimeout(() => {
					item.scrollIntoView({ behavior: 'instant', block: 'nearest', inline: 'center' });
				}, 0);
			}
		}
	}, 300);

	$effect.pre(() => {
		activeHeadingIdxs.subscribe(onActiveHeadingChange);
	});
</script>

<nav id="side-nav" class="scrollbar-hide w-full overflow-auto whitespace-nowrap">
	<ul class="index-bold text-gray-mid grid">
		{#key $headingsTree}
			{#each $headingsTree as heading, i (i)}
				<li class="py-1">
					<a
						href="#{heading.id}"
						use:melt={$item(heading.id)}
						class="hover:text-green-primary data-[active]:bg-green-primary/10 data-[active]:text-green-primary block rounded-md px-3 py-1"
					>
						{heading.title}
					</a>
				</li>
			{/each}
		{/key}
	</ul>
</nav>
